module.exports = __webpack_public_path__ + "static/media/users-white.6e4bdec8.svg";